import type { HandRaisedUser } from 'features/users/types';
import { createSelector } from '@reduxjs/toolkit';
import { selectSIPHandRaisedUsers } from 'features/sip/selectors/selectSIPHandRaisedUsers';
import { selectHandRaisedUsers } from 'features/users/selectors/selectHandRaisedUsers';

export const selectAllHandRaisedParticipants = createSelector(
  [selectHandRaisedUsers, selectSIPHandRaisedUsers],
  (handRaisedUsers, sipHandRaisedUsers) => {
    const allHandRaisedEntities: Record<string, HandRaisedUser> = {};

    for (const user of handRaisedUsers) {
      allHandRaisedEntities[user.id] = { ...user, userType: 'regular' };
    }

    for (const user of sipHandRaisedUsers) {
      allHandRaisedEntities[user.id] = { ...user, userType: 'sip' };
    }

    return allHandRaisedEntities;
  }
);
